import React from 'react';
import { ColGroup, SearchResultColumn, TableBody, TableHead } from '@css-xp/base';
import { CartLineItemsTableContainer } from './styles/cart-line-items-table-container';

const emptyStatePropForWrongSearch = {
  header: "We couldn't find any matches for your search",
  description: 'Check for typos or try different keywords.',
};

const errorStateProp = {
  header: "We can't show these details right now",
  description: "We can't show these details right now",
};

export const CartLineItemsTable = ({
  headerConfig,
  bodyComponent,
}: {
  headerConfig: SearchResultColumn[];
  bodyComponent: React.ReactNode;
}) => {
  return (
    <CartLineItemsTableContainer
      testId="product-line-item-table"
      totalCount={0}
      isPaginationEnabled={false}
      noResults={false}
      isLoading={false}
      error={undefined}
      errorStateProps={errorStateProp}
      emptyStateProps={emptyStatePropForWrongSearch}
      className="product-line-items-table"
      hasTableWrapper={true}
      shouldShowHorizontalScrollAnimation={true}
    >
      <ColGroup columns={headerConfig} />
      <TableHead columns={headerConfig} />
      <TableBody>{bodyComponent}</TableBody>
    </CartLineItemsTableContainer>
  );
};
